export const APP_BAR_HEIGHT = 64;
export const MOBILE_APP_BAR_HEIGHT = 56;

export const DRAWER_WIDTH = 256;
export const MOBILE_DRAWER_WIDTH = 224;
export const CLOSED_DRAWER_WIDTH = 65;
export const CLOSED_MOBILE_DRAWER_WIDTH = 57;

export const form = {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  margin: '0 auto',
  maxWidth: 600,
};

export const formButton = {
  margin: 10,
};

export const formWrapper = {
  alignSelf: 'stretch',
  display: 'flex',
  flexGrow: 1,
  flexWrap: 'wrap',

  // eslint-disable-next-line sort-keys
  '& > div': {
    flexGrow: 1,
    margin: 15,
  },
};

export const landingPageBgStyle = {
  backgroundSize: 'cover',
  height: '70vh',
  position: 'relative',
};

export const pageLayout = {
  paddingBottom: 30,
  paddingTop: 30,
};

export const relative = {
  position: 'relative',
};
